import { ChevronLeft, ChevronRight } from "lucide-react";

type Props = {
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
  label: string;
  disabled?: boolean;
  /** Chevron : gauche = élargir le lecteur, droite = refermer la liste. */
  expandToggle?: {
    expanded: boolean;
    onToggle: () => void;
  };
};

export function MailSplitResizer({
  onPointerDown,
  label,
  disabled = false,
  expandToggle,
}: Props) {
  const expanded = expandToggle?.expanded ?? false;

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={label}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onPointerDown={disabled ? undefined : onPointerDown}
      className={`mail-split-resizer shrink-0${disabled ? " mail-split-resizer--disabled" : ""}`}
    >
      {expandToggle ? (
        <button
          type="button"
          className="mail-split-expand-toggle"
          aria-label={expanded ? "Refermer la liste" : "Élargir la lecture"}
          aria-pressed={expanded}
          title={expanded ? "Refermer la liste" : "Élargir la lecture"}
          onPointerDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            expandToggle.onToggle();
          }}
        >
          {expanded ? (
            <ChevronRight className="h-3.5 w-3.5" aria-hidden />
          ) : (
            <ChevronLeft className="h-3.5 w-3.5" aria-hidden />
          )}
        </button>
      ) : null}
    </div>
  );
}
